import ContractCountDTO from "features/dashboard/contracts/dtos/ContractCountDTO";

export enum ContractsCountActionTypes {
  SET_CONTRACTS_COUNT = "@@contractsCount/SET_CONTRACTS_COUNT"
}

export type ContractsCountAction =
  | { type: ContractsCountActionTypes.SET_CONTRACTS_COUNT; data: ContractCountDTO[] };

export const setContractsCount = (data: ContractCountDTO[]): ContractsCountAction => {
  return {
    type: ContractsCountActionTypes.SET_CONTRACTS_COUNT,
    data: data,
  };
};